// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6c6825d7","455":"502da5c4","726":"816655bb","977":"677d7669"}[chunkId] + ".chunk.js";
};